import { render } from "./FooterBlack.vue?vue&type=template&id=95527560"
import script from "./FooterBlack.vue?vue&type=script&lang=js"
export * from "./FooterBlack.vue?vue&type=script&lang=js"

import "./FooterBlack.vue?vue&type=style&index=0&id=95527560&lang=scss"

import exportComponent from "../../../../../SINTEZ/store/frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__